import { Box } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useMemo } from 'react';
import Badge from '../Badge/Badge';
import ResetButton from '../ResetButton/ResetButton';

const hiddenLessons = ['2', '2.1', '2.2', '2.2.1', '2.3', '2.5'];

export default function Budgets() {
    const game = useGame();
    const page = usePage();

    const { highlightBudget, highlightEarnings } = game.lessonProps;

    const hide = useMemo(() => {
        return page.lessonParent < 2 || !page.lesson || hiddenLessons.includes(page.lesson);
    }, [page.lesson, page.lessonParent]);

    if (hide) {
        return null;
    }

    return (
        <Box alignItems="flex-start" display="flex" flexDirection="column" gap={1} justifyContent="center">
            <Badge
                highlight={highlightBudget}
                info="budget"
                label="Budget"
                tabIndex={12}
                type="currency"
                value={game.budget}
            />
            <Badge
                highlight={highlightEarnings}
                info="earnings"
                label="Earnings"
                tabIndex={13}
                type="currency"
                value={game.earnings}
            />
            {!game.lessonProps.hideResetButton && <ResetButton />}
        </Box>
    );
}
